<template>
  <p>
    <i18n-t v-if="!secondTelephone" keypath="contact site one phone">
      <template #telephone>
        <a :href="`tel:${telephone}`">{{ telephone }}</a>
      </template>
      <template #email>
        <a :href="`mailto:${email}`">{{ email }}</a>
      </template>
    </i18n-t>

    <i18n-t v-else keypath="contact site two phones">
      <template #telephone>
        <a :href="`tel:${telephone}`">{{ telephone }}</a>
      </template>
      <template #secondTelephone>
        <a :href="`tel:${secondTelephone}`">{{ secondTelephone }}</a>
      </template>
      <template #email>
        <a :href="`mailto:${email}`">{{ email }}</a>
      </template>
    </i18n-t>
  </p>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class ThanksPageContactTheSite extends Vue {
  @Prop()
  telephone: string

  @Prop()
  secondTelephone: string

  @Prop()
  email: string
}

export default toNative(ThanksPageContactTheSite)
</script>
